import './styles.scss'

const TableContainer = ({ className = '', children }) => <div className={`table ${className}`}>{children}</div>

export default TableContainer
